<template>
  <b-card title="Network Provider Monitoring">
    <template #default>
      <vue-element-loading :active="loader" />
      <b-table ref="providerTable" :items="table.items" :fields="table.fields" small responsive>
        <template #cell(name)="data">
          <b-icon icon="circle-fill" :variant="statusConverter(data.item).color" />
          <b class="ml-1">{{ data.item.name }}</b>
        </template>
        <template #cell(status)="data">
          <span :class="`text-${statusConverter(data.item).color}`">
            {{ statusConverter(data.item).status }}
          </span>
        </template>
        <template #cell(lastUpdate)="data">
          <span v-if="data.item.batchTask.length > 0">
            {{ data.item.batchTask[0].startDate | time }}
          </span>
        </template>
        <template #cell(action)="data">
          <b-button
            :variant="data.item.isOnline ? `outline-danger` : `outline-success`"
            :disabled="data.item.loader"
            size="sm"
            @click.stop="toggleOnlineStatus(data.item)"
          >
            <b-icon icon="loader" v-if="data.item.loader" />
            {{ data.item.isOnline ? `Turn Offline` : `Turn Online` }}
          </b-button>
        </template>
      </b-table>
    </template>
  </b-card>
</template>

<script>
import api from "@api";

export default {
  name: "ProviderStatus",
  data() {
    return {
      table: {
        items: [],
        fields: [
          { key: "name", label: "Provider" },
          { key: "status", label: "Status", class: `text-right` },
          { key: "lastUpdate", label: "Last Update", class: `text-right` },
          { key: "action", label: "", class: `text-right` },
        ],
      },
      loader: false,
    };
  },
  computed: {},
  mounted() {
    this.getProviderList();
  },
  methods: {
    async getProviderList() {
      this.loader = true;
      try {
        this.table.items = await api.get(`provider`);
      } catch (error) {
        this.showToast(`error`, error);
      } finally {
        this.loader = false;
      }
    },
    statusConverter(row) {
      if (!row.isOnline) return { status: "Offline", color: "danger" };

      if (!row.batchTask || row.batchTask.length === 0) {
        return { status: "Init", color: "info" };
      }

      var TEN_MINUTES_IN_MS = 10 * 60 * 1000;
      const task = row.batchTask[0];
      const startDate = new Date(task.startDate).getTime();
      const now = Date.now();

      if (now - startDate > TEN_MINUTES_IN_MS) {
        return { status: "Offline", color: "danger" };
      }

      if (!task.endDate) {
        return { status: "Running", color: "primary" };
      }

      return { status: "Stand By", color: "success" };
    },
    async toggleOnlineStatus(row) {
      row.loader = true;
      try {
        await api.put(`provider/online/${row.id}`);
        row.isOnline = !row.isOnline;
        this.showToast(`success`, `Provider ${row.name} is now ${row.isOnline ? `Online` : `Offline`}`);
        this.$refs.providerTable.refresh();
      } catch (error) {
        this.showToast(`error`, error);
      } finally {
        row.loader = false;
      }
    },
  },
};
</script>
